<template>
  <app-dialog
    v-model="openModel"
    content-class="dialogGuaranteeReduceIncome guaranteeModal"
    @onClose="$emit('onClose')"
  >
    <template v-slot:title>
      <h1 class="dialogGuaranteeReduceIncome-title">収入減少に備える補償</h1>
    </template>
    <v-card class="dialogGuaranteeReduceIncome-content">
      <v-card-text class="dialogGuaranteeReduceIncome-content">
        <div class="his-tbl_wrapper">
          <table>
            <tbody>
              <tr>
                <th colspan="5">補償内容</th>
              </tr>
              <tr>
                <th></th>
                <th>Ｙ型</th>
              </tr>
              <tr>
                <td>１口あたりの<br />補償額</td>
                <td data-label="Ｙ型">１０万円／月<br /></td>
              </tr>
              <tr>
                <td>ご加入条件</td>
                <td data-label="Ｙ型">
                  Ａ型・Ｅ型・Ｇ型のいずれかとセットで加入が必要
                </td>
              </tr>
              <tr>
                <td>口数の制限</td>
                <td data-label="Ｙ型">
                  １～５口の範囲内でかつ補償額がご加入(申込日)直前１２か月における所得の平均月間額の４０％以内となるようにお申込みください
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card-text>
    </v-card>
  </app-dialog>
</template>

<script>
export default {
  name: 'DialogGuaranteeReduceIncome',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    openModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">
.dialogGuaranteeReduceIncome {
  width: 690px;
  max-width: 700px;
  &-content {
    &.v-card__text {
      padding: 0 30px 20px;
    }
  }
  &-title {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #333;
    margin-top: 15px;
    margin-bottom: 5px;
    width: 100%;
  }
}
</style>
